<template>
    <div class="box">
        <div class="title">
          {{questionnaireData.title}}
        </div>
        <div class="img">
          <van-image
            v-if="questionnaireData.img_url !== ''"
            :src="questionnaireData.img_url"
          />
        </div>
        <div class="desc">
          <div class="test">
            {{questionnaireData.desc}}
          </div>
        </div>
        <div class="roughly_data">
            <div class="roughly_data_surface">
                <van-circle
                    v-model="currentRate"
                    :rate="rate"
                    :speed="100"
                    :text="text"
                    :clockwise="false"
                    color="#19cca0"
                    layer-color="#e7edf5"
                    size="80px"
                    :stroke-width="150"
                />
            </div>
            <div class="roughly_data_text">
              <div>总计人数：<span>{{survey_total_cnt}}人</span></div>
              <div>完成人数：<span>{{questionnaireData.done_cnt}}人</span></div>
            </div>
        </div>
        <DIVISIONPROPORTION v-if="questionnaireData.dep_user_cnt > 0" v-bind="questionnaireData" :done_cnt="questionnaireData.done_cnt" />
        <div v-for="(item, index) in questions" :key="item.question_id">
            <QUESTIONNAIRESELECT v-if="item.topic_id === 1 || item.topic_id === 2" v-bind="item" :done_cnt="questionnaireData.done_cnt" :index='index' />
            <QUESTIONNAIRESCORE v-else-if="item.topic_id === 5" v-bind="item" :done_cnt="questionnaireData.done_cnt" :index='index' />
            <QUESTIONNAIREINPUT v-else-if="item.topic_id === 3 || item.topic_id === 4" v-bind="item" :done_cnt="questionnaireData.done_cnt" :index='index' />
            <QUESTIONNAIREMATRIX v-else-if="item.topic_id === 6 " v-bind="item" :done_cnt="questionnaireData.done_cnt" :index='index' />
        </div>
    </div>
</template>

<script>
import QUESTIONNAIRESELECT from './components/questionnaireSelect.vue'
import QUESTIONNAIRESCORE from './components/questionnaireScore.vue'
import QUESTIONNAIREINPUT from './components/questionnaireInput.vue'
import DIVISIONPROPORTION from './components/divisionProportion.vue'
import QUESTIONNAIREMATRIX from './components/questionnaireMatrix.vue'
import { getQuestionnaireResiltDetail } from '@/api/api'
import { get } from '../../../utils/token'
export default {
  data () {
    return {
      rate: 0,
      currentRate: 0,
      // currentRate: this.questionnaireData !== '' ? this.questionnaireData.done_cnt / this.survey_total_cnt * 100 : 0,
      kuandu: 80,
      value: 3.5,
      questionnaireData: {},
      questions: [],
      survey_total_cnt: ''
    }
  },
  components: {
    QUESTIONNAIRESELECT,
    QUESTIONNAIRESCORE,
    QUESTIONNAIREINPUT,
    DIVISIONPROPORTION,
    QUESTIONNAIREMATRIX
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    // 获取问卷详情
    async getDetail () {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...'
      })
      const mobile = get('mobile')
      try {
        const data = await getQuestionnaireResiltDetail(mobile, this.$route.query.questionnaire_id)
        if (data.code === 200) {
          this.$toast.clear()
          this.questionnaireData = data.data
          this.questions = data.data.questions
          this.survey_total_cnt = data.data.survey_total_cnt
        }
      } catch (error) {
        this.$toast.clear()
      }
    }
    // computeCurrentRate () {
    //   // this.$nextTick(() => {
    //   return this.questionnaireData.done_cnt / this.survey_total_cnt * 100
    //   // })
    // }
  },
  computed: {
    text () {
      return (this.questionnaireData.done_cnt / this.survey_total_cnt * 100 || 0).toFixed(2) + '%'
    }
  },
  watch: {
    questionnaireData () {
      this.rate = Math.floor(this.questionnaireData.done_cnt / this.survey_total_cnt * 100 || 0)
    }
  }
}
</script>

<style lang='scss' scoped>
.box{
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: scroll;
    // 此处不是最好的样式处理方案
    background-color: #f2f8fc;
    .img{
      width: 91.47%;
      margin: 10px auto 0;
    }
    .title{
        width: 91.47%;
        height: 30px;
        line-height: 30px;
        margin: 0 auto;
        padding-top: 20px;
        font-size: 20px;
        font-weight: 600;
        text-align: center;
    }
    .desc{
      width: 91.47%;
      margin: 0 auto;
      background: #fff;
      border-radius: 12px;
      .test{
        width: 91.47%;
        margin: 10px auto;
        padding: 5px 0;
        // text-indent:2em
      }
    }
    .roughly_data{
        width: 91.47%;
        height: 120px;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 12px;
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        .roughly_data_surface{
            margin: auto 0;
            margin-left: 40px;
        }
        .roughly_data_text{
            margin: auto 0;
            margin-right: 40px;
            div:nth-child(1){
                margin-bottom: 10px;
            }
        }
    }
}
</style>
